import React from 'react'

const ClientItemDescription = (invoiceData) => {
    var total = 0;
    var totalCost = 0;
    return (
        <>
            <style>
                {`
                    @keyframes pulse {
                        0%, 100% {
                            opacity: 1;
                        }
                        50% {
                            opacity: 0.5;
                        }
                    }
                `}
            </style>
            <div className="table-inner-outmain22">
                <table className="invo-single-tb1">
                    <thead>
                        <tr className=" mainborder-bottom">
                            <td>Item</td>
                            <td >Description</td>
                            <td>Cost</td>
                            <td>VAT %</td>
                            <td>Price</td>

                        </tr>
                    </thead>
                    <tbody>
                        {invoiceData.invoiceData.length > 0 ?
                            invoiceData.invoiceData[0].Invoice_Details.map((item, index) => {
                                total = total + parseFloat(item.Price);
                                totalCost = totalCost + parseFloat(item.Cost);
                                return (<tr valign="top" className="border-bottomiteam infotablem" key={item._id || index}>
                                    <td>{index + 1}</td>
                                    <td style={{ maxWidth: "300px",paddingRight: "30px" }} >{item.Description}</td>
                                    <td>{new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData.invoiceData[0].cli_inv_currency, }).format(item.Cost)}</td>

                                    <td>{item.VAT}</td>
                                    <td>{new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData.invoiceData[0].cli_inv_currency, }).format(item.Price)}</td>
                                </tr>)
                            })
                            :
                            [...Array(3)].map((_, index) => (
                                <tr key={index} className="border-bottomiteam infotablem">
                                    <td>
                                        <div
                                            style={{
                                                width: "30px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "300px", paddingRight: "30px" }}>
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                width: "80px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                width: "60px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                width: "80px",
                                                height: "20px",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))
                        }
                        <tr className="sub-bordertotal reborder sub-bordertotal-new">
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td>Subtotal</td>
                            <td className="tab-totalsubvat">{invoiceData.invoiceData.length > 0 ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData.invoiceData[0].cli_inv_currency, }).format(totalCost)) : (
                                <div
                                    style={{
                                        width: "80px",
                                        height: "20px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</td>
                        </tr>
                        <tr className="vat-bordertotal reborder">
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td>VAT</td>
                            <td className="tab-totalvat">{invoiceData.invoiceData.length > 0 ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData.invoiceData[0].cli_inv_currency, }).format(parseFloat(total) - parseFloat(totalCost))) : (
                                <div
                                    style={{
                                        width: "80px",
                                        height: "20px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</td>
                        </tr>
                        <tr className="total-bordertotal reborder">
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td className="mob-no-need"></td>
                            <td className="invo-totalfd">Invoice Total</td>
                            <td className="tab-totalamt">{invoiceData.invoiceData.length > 0 ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData.invoiceData[0].cli_inv_currency, }).format(total)) : (
                                <div
                                    style={{
                                        width: "80px",
                                        height: "20px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ClientItemDescription